import { useRecoilState } from 'recoil'
import type { SetterOrUpdater } from 'recoil'
import { editorLotusEnabledAtom } from '@/atoms/editorTextBoxAtoms'
import { useEditorLotusOffered } from '@/hooks/editor/useEditorLotusOffered'

const ignoreLotusEnabledChange: SetterOrUpdater<boolean> = () => {}

/**
 * The new text boxes switch: whether internal staff's text inserts make Lotus
 * boxes outside a turned-over page set (`useEditorInsertsLotus`). It starts
 * on (`editorLotusEnabledAtom`). Only internal staff, and only where Lotus text boxes are offered
 * for the open order's funeral home (`useEditorLotusOffered`), read the stored
 * setting and change it. Everyone else, and internal staff anywhere else,
 * reads it as off whatever this browser has stored, and their setter changes
 * nothing, so the stored setting is still there for the next internal admin
 * where Lotus is offered.
 */
export const useEditorLotusEnabled = (): [
  boolean,
  SetterOrUpdater<boolean>,
] => {
  const offered = useEditorLotusOffered()
  const [enabled, setEnabled] = useRecoilState(editorLotusEnabledAtom)
  return offered ? [enabled, setEnabled] : [false, ignoreLotusEnabledChange]
}

export default useEditorLotusEnabled
